export default function () {
    const authUser = window.addiesaas.store.getters['authUser']
    return authUser ? authUser.id : null
}
